import React from 'react'
import { useHistory } from 'react-router-dom'

export default function NotInStudyContainer(props) {
  const history = useHistory()

  const onBack = () => {
    history.push('/login')
  }

  return (
    <div className="screen">
      <div className="navigation-bar">
        <div className="button-item back" onClick={onBack}>
          <img src={require('../images/icon_back_arrow.png')} alt="arrow" className="arrow" />
          Back
        </div>
        <div className="title">EL-FIT</div>
      </div>
      <div className="content-flex" style={{ marginTop: 40 }}>
        <h3>Not in the EL-FIT program?</h3>
        <p>
          The EL-FIT application is currently only available to participants of the official study.
          If you're interested in becoming a study participant, please email the program
          administrators for more information.
        </p>
        <p>[Ability for non-participants to watch videos coming soon]</p>
      </div>
    </div>
  )
}
